import { useState, useRef } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        {/* Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
              Product Categories
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              Browse by{" "}
              <span className="text-primary-600">Category</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-md">
              Every category links to verified product listings on the main acbuy spreadsheet platform
            </p>
          </div>

          {/* Scroll Arrows */}
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll("left")}
              className="w-10 h-10 rounded-full bg-background-50 border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-foreground-700"></i>
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-10 h-10 rounded-full bg-background-50 border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-foreground-700"></i>
            </button>
          </div>
        </div>

        {/* Scrollable Cards */}
        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:-mx-8 md:px-8"
          style={{ scrollSnapType: "x mandatory", WebkitOverflowScrolling: "touch" }}
        >
          {categories.map((cat, idx) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[220px] md:w-[250px] group cursor-pointer"
              style={{ scrollSnapAlign: "start" }}
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} products available in the acbuy spreadsheet`}
                  title={`${cat.name} - ACBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              {/* Info */}
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800 truncate">{cat.name}</p>
                  <p className="text-xs text-foreground-500 truncate">{cat.description}</p>
                </div>
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 ml-2 group-hover:bg-primary-200 transition-colors">
                  <i className="ri-arrow-right-up-line text-primary-600 text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}